import { auth } from '../config';
import { type ItemListType } from '../../../types/common';
import { PatternFileType } from '../../../types/pattern';
import { ValidationError } from '../../../modules/error';

// APIレスポンス型定義
export interface ItemListResponse {
  documentName: string | null;
  items: ItemListType[];
}

// オーバーロード定義
export async function handleOcrItemList(files: File[]): Promise<ItemListResponse>;
export async function handleOcrItemList(
  files: File[],
  existingFiles: PatternFileType[],
): Promise<ItemListResponse>;

// getItemList関数を実行する（HTTP版）- 複数ファイル対応（multipart/form-data送信）
export async function handleOcrItemList(
  files: File[],
  existingFiles?: PatternFileType[],
): Promise<ItemListResponse> {
  // 認証トークンを取得
  if (!auth.currentUser) {
    throw new Error('ユーザーがログインしていません。');
  }

  const idToken = await auth.currentUser.getIdToken();

  // Cloud Functionsエンドポイントを呼び出し
  const functionUrl = process.env.REACT_APP_FUNCTION_URL;

  if (!functionUrl) {
    throw new Error('REACT_APP_FUNCTION_URL environment variable is not set');
  }

  if (files.length === 0 && (!existingFiles || existingFiles.length === 0)) {
    throw new ValidationError('処理するファイルがありません。');
  }

  // すべてのケースでmultipart/form-dataを使用（パフォーマンス向上）
  const formData = new FormData();

  // 既存ファイル情報を追加（JSON文字列として）
  if (existingFiles && existingFiles.length > 0) {
    const existingFileData = existingFiles.map(file => ({
      type: 'existing',
      fileName: file.file_name,
      storagePath: file.storage_path,
    }));
    formData.append('existingFiles', JSON.stringify(existingFileData));
    formData.append('mixed', 'true');
  }

  // 新規ファイルを直接追加（base64変換なし - パフォーマンス向上）
  files.forEach(file => {
    formData.append('files', file);
  });

  const response = await fetch(`${functionUrl}/getItemList`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${idToken}`,
      // Content-Typeは自動設定されるので指定しない
    },
    body: formData,
  });

  if (!response.ok) {
    throw new Error('AI読取に失敗しました。時間をおいて再度お試しください。');
  }

  const result = await response.json();
  return result as ItemListResponse;
}
